import { render, staticRenderFns } from "./PortalFooter.vue?vue&type=template&id=39a01dd9&scoped=true&"
import script from "./PortalFooter.vue?vue&type=script&lang=js&"
export * from "./PortalFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a01dd9",
  null
  
)

export default component.exports